import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownOption(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownOption',
    baseStyle: {
      borderBottom: `1px solid ${theme.colors.border}`,
      backgroundColor: 'transparent',

      ['&:last-child']: {
        border: 'none'
      },

      ['&:hover']: {
        backgroundColor: theme.colors.tableRowHover
      }
    }
  };
}
